import { Action, createReducer, on } from '@ngrx/store';
import { UtmActions } from './utm.actions';
import { IUtmState } from './utm.state';

export const initialUtmState: IUtmState = {
  utmSource: undefined,
  utmMedium: undefined,
  utmCampaign: undefined,
  utmTerm: undefined,
  utmContent: undefined
};

const utmReducerFn = createReducer(
  { ...initialUtmState },
  on(UtmActions.reset, () => {
    return { ...initialUtmState };
  }),
  on(UtmActions.loadParams, (state: IUtmState, action) => action.model)
);

export function utmReducer(state: IUtmState | undefined, action: Action) {
  return utmReducerFn(state, action);
}
